/*=========================================================================================
  File Name: moduleMapState.js
  Description: Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	toggleMapSidebar: false,
	popupStreeViewActive: false,
	visitPointsMarkers: [],
	visitPointsMarkersDatarutas: [],
};
